import { LocationEntity } from 'Models/Entities';
import { JourneyElementsDto } from '../Types/JourneyElementsDto';
import { sortByOrder } from './sortByOrder';

export const getValidDestinationLocations = (
	journeyElements: JourneyElementsDto,
	startLocationId: string,
	orgId?: string | null,
) => {
	const possibleDestinations = new Set<LocationEntity>();
	const { routes } = journeyElements;

	const filteredRoutes = orgId ? routes.filter(x => x.organisationIds?.includes(orgId) ?? true) : routes;

	// Iterate through routes to find possible destinations
	for (const route of filteredRoutes) {
		let foundSelectedStop = false;

		for (const stop of route.stops.slice().sort(sortByOrder())) {
			// If the stop matches the selected location, mark it as the starting point
			if (stop.locationId === startLocationId && !foundSelectedStop) {
				foundSelectedStop = true;
			} else if (foundSelectedStop) {
				// If the selected location has been found, collect all stops that follow
				possibleDestinations.add(stop.location);
			}
		}
	}

	return Array.from(possibleDestinations.values());
};
